import { render, staticRenderFns } from "./PaySuccess.vue?vue&type=template&id=5d052a5b&"
import script from "./PaySuccess.vue?vue&type=script&lang=js&"
export * from "./PaySuccess.vue?vue&type=script&lang=js&"
import style0 from "./PaySuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports